import React, {useEffect, useState} from "react";
import {TicketModal} from "./TicketModal";
import {
    registerTicketModalCallback,
    getTicketModalState,
    closeTicketModal
} from "./TicketModalService";

export const GlobalTicketModalManager: React.FC = () => {
    const [modalState, setModalState] = useState(getTicketModalState());

    useEffect(() => {
        // Register this component to receive modal state changes
        const unregister = registerTicketModalCallback(setModalState);

        return unregister;
    }, []);

    const handleCloseModal = () => {
        closeTicketModal();
    };

    if (
        !modalState.isOpen ||
        !modalState.locationPk ||
        !modalState.orderDate ||
        !modalState.ticketNumber
    ) {
        return null;
    }

    return (
        <TicketModal
            isOpen={modalState.isOpen}
            onClose={handleCloseModal}
            locationId={modalState.locationPk}
            businessDate={modalState.orderDate}
            ticketNumber={modalState.ticketNumber}
        />
    );
};
